package com.havn.app.core.designsystem

internal actual val havnUsesLiquidButtons: Boolean = false

internal actual val havnUsesLiquidSidebar: Boolean = false

internal actual val havnUsesMaterialSidebar: Boolean = false

internal actual val havnNeedsNativeTabBarContentInset: Boolean = false

internal actual val havnUsesRootSafeDrawingInsets: Boolean = true

internal actual val havnUsesRootStatusBarInsets: Boolean = false

actual val havnIsWebShell: Boolean = true
